import './App.css';
import Layout from './features/layout/Layout';
import Tracing from './features/tracing/Tracing';
import TracingCrud from './features/tracingCrud/TracingCrud';
import { Provider } from 'react-redux';
import { store } from './shared/store/store';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './shared/api/queryClient';
import { useState } from 'react';
import { type NavItem } from './shared/components/NavigationDrawer';
import HomeIcon from "@mui/icons-material/Home";
import BuildIcon from '@mui/icons-material/Build';
import { Toaster } from 'sonner';

function App() {
    const [activeView, setActiveView] = useState<'tracing' | 'crud'>('tracing');

    const navItems: NavItem[] = [
        { label: "Home", icon: <HomeIcon fontSize="small" />, onClick: () => setActiveView('tracing') },
        { label: "Mantenimiento de clientes y suscripciones", icon: <BuildIcon fontSize="small" />, onClick: () => setActiveView('crud') },
    ];

    return (
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <Toaster richColors position="bottom-right" />
                <Layout items={navItems}>
                    {activeView === 'crud' ? <TracingCrud /> : <Tracing />}
                </Layout>
            </QueryClientProvider>
        </Provider>
    );
}

export default App;